var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-child box pt-6 pb-6 is-unselectable is-tertiary placeholder-card"},[_c('b-loading',{attrs:{"is-full-page":false,"active":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }